export default class BarbaBodyHelper {
	constructor() {}

	getClassesAndDataAttributes(data) {
		if (data.current.container) {
			let nextHtml = data.next.html
			let parser = new DOMParser()

			let htmlDoc = parser.parseFromString(nextHtml.replace(/(<\/?)(body)( .+?)?>/gi, '$1notbody$3>', nextHtml), 'text/html')

			let bodyClasses = htmlDoc.body.getAttribute('class')

			if (bodyClasses) {
				// Get existing body classes and split them
				let existingClasses = new Set(document.body.className.split(' '))

				// Filter persistent classes that are already present
				let persistentClasses = ['preloaded'].filter((className) => existingClasses.has(className))

				// Combine persistent classes with the new ones
				let newClasses = bodyClasses.split(' ').filter((className) => !persistentClasses.includes(className))
				let finalClasses = new Set([...persistentClasses, ...newClasses])

				// Update the body classes
				document.body.className = Array.from(finalClasses).join(' ')
			}

			// Remove all existing data attributes
			for (const attr of [...document.body.attributes]) {
				if (attr.name.startsWith('data-s')) {
					document.body.removeAttribute(attr.name)
				}
			}

			// Add new data attributes
			let bodyDataAttrs = htmlDoc.body.attributes

			for (const attr of bodyDataAttrs) {
				if (attr.name.startsWith('data-s')) {
					document.body.setAttribute(attr.name, attr.value)
				}
			}
		}
	}
}
